import React from 'react';
import { Link } from 'react-router-dom';
import './CareerNavbar.css';

const CareerNavbar = () => {
    return (
        <nav className="navbar navbar-expand-lg navbar-light bg-white py-3 shadow-sm fixed-top career-navbar">
            <div className="container-fluid px-5">
                <Link className="navbar-brand d-flex align-items-center gap-2" to="/career">
                    <div className="d-flex align-items-center justify-content-center rounded-circle career-navbar-brand-icon">
                        <span style={{ fontSize: '24px' }}>👋</span>
                    </div>
                    <span className="fw-bolder text-dark career-navbar-brand-text">#hiring</span>
                </Link>

                <button
                    className="navbar-toggler"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#careerNavbar"
                    aria-controls="careerNavbar"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div className="collapse navbar-collapse" id="careerNavbar">
                    <ul className="navbar-nav ms-auto align-items-center mb-2 mb-lg-0 gap-lg-4">
                        {/* <li className="nav-item">
                            <a className="nav-link fw-bold text-dark career-nav-link" href="#journey">Journey</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link fw-bold text-dark career-nav-link" href="#culture">Culture @360</a>
                        </li>
                        <li className="nav-item">
                            <a className="nav-link fw-bold text-dark career-nav-link" href="#faqs">FAQs</a>
                        </li> */}
                        <li className="nav-item ms-lg-3">
                            <a href="#openings" className="btn text-uppercase fw-bold rounded-3 ps-4 pe-4 py-2 d-flex align-items-center gap-3 text-white career-find-position-btn">
                                FIND POSITION
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
    );
};

export default CareerNavbar;
